<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-row>
          <el-steps :active="urlQrGenerateProcess" class="stepClass" align-center="true">
            <!-- <el-step title="输入网址" icon="fa fa-edit fa-2x"></el-step> -->
            <el-step><span slot="title"><i class="fa fa-edit fa-x"></i>输入网址</span></el-step>
            <el-step><span slot="title"><i class="fa fa-upload fa-x"></i>上传图像</span></el-step>
            <el-step><span slot="title"><i class="fas fa-cut fa-x"></i>裁剪生成</span></el-step>
            <el-step><span slot="title"><i class="far fa-save fa-x"></i>保存图片</span></el-step>
          </el-steps>
        </el-row>
        <el-row>
          <!-- 第一个步骤 填写内容 -->
          <el-col v-if='urlQrGenerateProcess==0' :span="24">
            <el-form label-position="top" :model="qrWebInfoForm" :rules="qrWebRules" ref="qrWebInfoForm" class="qrWebInfoForm">
              <el-form-item label="" prop="url">
                <el-input v-model.trim="qrWebInfoForm.url" onkeydown="if(event.keyCode==13)return false;" class="input"></el-input>
              </el-form-item>
              <el-form-item style="text-align: center;">
                <el-button @click="secondStep('qrWebInfoForm')" class="button1">下一步</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <!-- 第二个步骤  上传图像 -->
          <el-col v-if="urlQrGenerateProcess == 1" :span="24"  style="text-align: center;">
            <el-upload drag class="qr-src-uploader" action="" :on-change="onUploadChange" :multiple="false" :auto-upload="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将图片拖到此处，或
                <em>点击上传</em>    
              </div>
            </el-upload>
            <el-button @click="urlQrGenerateProcess--" class="button2">上一步</el-button>
          </el-col>
          <!-- 第三个步骤  裁剪图像 -->
          <el-col v-if="urlQrGenerateProcess == 2" :span="24" style="text-align: center;">
            <cropper :src="selectedPic.url" @api="getCropApi" class="cropper"></cropper>
            <el-button @click="urlQrGenerateProcess--" class="button3">上一步</el-button>
            <el-button @click="cropImage" class="button4">生成美钥码</el-button>
          </el-col>
          <!-- 第四个步骤，预览生成的图片进行下一步操作 -->
          <el-col v-if="urlQrGenerateProcess == 3" :span="24" style="text-align: center;">
            <div style="text-align:center;margin-top:20px;">
              <img :src="'/qrdata/temp/' + qr.qrfile" class="disqr" alt="美钥二维码">
            </div>
            <div class="button_box">
              <el-button @click="urlQrGenerateProcess--" class="button5">重新裁剪</el-button>
              <el-button @click="saveQr" class="button6">保存图片</el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="7">
        <div class="scale-fit">
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/javascript">
import $ from 'jquery'
import cropper from './cropper.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'qrUrl',
  components: {
    cropper
  },
  data () {
    // 校验函数，检验网址是否为url
    let isUrl = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('网址不能为空'))
      } else if (value.length > 2083) {
        callback(new Error('网址太长，请尝试输入短网址'))
      } else if (!(value.slice(0, 'http://'.length) === 'http://' || value.slice(0, 'https://'.length) === 'https://')) {
        callback(new Error('网址应该以"http://"或者"https://"开头'))
      } else if (value === 'http://' || value === 'https://') {
        callback(new Error('请填入具体网址'))
      } else {
        callback()
      }
    }
    return {
      urlQrGenerateProcess: 0,
      imageUrl: '',
      // 网址
      qrWebInfoForm: {
        url: 'http://'
      },
      // 校验网址是否合乎规定
      qrWebRules: {
        url: [
          { validator: isUrl, trigger: 'click' }
        ]
      },
      selectedPic: '', // 上传的图像本地文件地址及名称，blob
      cropperApi: undefined,
      // canvasDataURL: undefined // canvas data
      qr: undefined // 生成的二维码
    }
  },
  computed: {
    ...mapGetters(['logined', 'username'])
  },
  mounted () {
    document.title = '美钥二维码 - 制作网址美钥码'
  },
  methods: {
    // 校验第一步输入的内容，并进入第二步
    secondStep (formName) {
      const vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          vm.urlQrGenerateProcess = 1
        } else {
          return false
        }
      })
    },
    onUploadChange (file) {
      const vm = this
      // 进入第3步
      vm.selectedPic = file
      vm.urlQrGenerateProcess = vm.urlQrGenerateProcess + 1
    },
    getCropApi (api) {
      this.cropperApi = api
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    cropImage () {
      const vm = this
      if (vm.cropperApi) {
        let canvas = vm.cropperApi.getCroppedCanvas({
          width: 512
        })
        let canvasDataURL = canvas.toDataURL('image/jpeg')
        let blob = vm.dataURLtoBlob(canvasDataURL)
        // 上传图像，并进行图像生成
        let formData = new FormData()
        formData.append('url', vm.qrWebInfoForm.url)
        formData.append('srcImage', blob, 'cropImage.jpg')
        formData.append('resource', '')
        formData.append('type', 'url')
        $.ajax({
          url: '/v1/generate/qr',
          type: 'POST',
          data: formData,
          async: false,
          enctype: 'multipart/form-data',
          processData: false,  // 告诉jQuery不要去处理发送的数据
          contentType: false,   // 告诉jQuery不要去设置Content-Type请求头
          cache: false
        })
        .done(function (data) {
          // 接受生成的二维码信息数据
          vm.qr = data.data
          // 跳转到下个界面
          vm.urlQrGenerateProcess ++
          vm.resourceQrGenerateProcess ++
        })
        .fail(function () {
          vm.$message.error('请求错误，请稍后再试！')
        })
      }
    },
    // 保存生成的美钥码
    saveQr () {
      const vm = this
      vm.$http.put(`/v1/user/qrs/${vm.qr.qrid}/owner`)
      .then(response => {
        if (response.data.code === 200) {
          vm.$message.info('保存成功！')
          vm.$router.push('/labelManage/labelid/all/n/10/p/1')
        } else {
          vm.$message.error('保存失败，请稍后再试')
        }
      }).catch((error) => {
        console.log(error)
        if (error.response.status === 507) {
          // 空间资源不足
          if (error.response.data.code === 507001) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者清理部分空间后重试。')
          // 二维码空间不足
          } else if (error.response.data.code === 507002) {
            vm.$message.warning('用户资源空间不足，请升级套餐进行扩容，或者删除部分二维码后重试。')
          }
        }
      })
    }
  }
}
</script>
<style type="text/css">
/* 手机屏幕模拟 */
.scale-fit{
  width: 0px;
  height: 0px;
  transform: scale(0.6);
  transform-origin:0 0;
  -ms-transform: scale(0.6); /* IE 9 */
  -ms-transform-origin:0 0;     /* IE 9 */
  -moz-transform: scale(0.6); /* Firefox */
  -moz-transform-origin:0 0;    /* Firefox */
  -webkit-transform: scale(0.6); /* Safari and Chrome */
  -webkit-transform-origin:0 0; /* Safari 和 Chrome */
  -o-transform: scale(0.6); /* Opera */
  -o-transform-origin:0 0;    /* Opera */
}
.brower-simulate {
  background: #D3DCE6;
  height: 30px; 
  margin-top: 8px;
  border-radius: 5px;
}
.url-simulate {
  height: 30px;
  color: black;
  font-size: 21px;
  overflow:hidden;
  text-overflow:ellipsis;
}
.cancel-simulate {
  font-size: 25px;
  color: #20A0FF;
  margin-top: 8px;
}
.close-simulate {
  font-size: 12px;
  float: right;
  margin-top: 7px;
  margin-right: 5px;
  color: #F9FAFC;
  background-color: #99A9BF;
  border-radius: 8px;
  padding: 3px;
}
/* 上载页面 */
.qr-src-uploader {
  text-align: center;
  margin-top:170px;
}
.qr-src-uploader :hover {
  border-color: #20a0ff;
}
/* crop */
/* Limit image width to avoid overflow the container */
#imageCrop {
  max-width: 80%; /* This rule is very important, please do not ignore this! */
  border: 1px dashed #d9d9d9;
}
.stepArea {
  height: 100px;
  width: 100%;
  text-align: center;
  padding-top: 50px;
  background: url('../../assets/img/generate/213123.jpg');
  background-repeat: no-repeat;
  background-size: cover;
}
.step {
  margin-left: 20%;
}
.stepClass {
  background-image: url('../../assets/img/images/38.jpg');
  background-size: cover;
  padding-top: 30px;
  padding-bottom: 30px;
}
.el-step__title.is-process {
  color: white;
}
.el-step__title.is-finish {
  color: #11c181;
}
.el-step__head.is-finish {
  color: #11c181;
  border-color: #11c181;
}
.step-icon {
  width: 50px;
  height: 50px;
  margin-top: -80px;
}
.qrWebInfoForm {
  width: 700px;
  margin: 200px auto auto;
}
.button1:hover,
.button4:hover,
.button6:hover {
  color: white;
  border:1px solid #fe816d;
  background: #f4584d;
}
.button2:hover,
.button3:hover,
.button5:hover {
  color: white;
  border:1px solid #38dba4;
  background: #11c181;
}

.button1,
.button2,
.button3,
.button4,
.button5,
.button6 {
  border-radius: 30px;
  font-size: 25px;
  letter-spacing: 3px;
}
.button1, .button4, .button6 {
  background:#fe816d;
  width: 280px;
  margin-left: auto;
  margin-right: auto;
  color:white;
  border: 1px solid #fe816d;
}
.button2, .button3, .button5 {
  background:#38dba4;
  width: 280px;
  margin-left: auto;
  margin-right: auto;
  color:white;
  margin-top:50px;
  border: 1px solid #38dba4;
}
.button3, .button4, .button5, .button6 {
  margin-top: 0px;
}
.button_box {
  width: 100%;
  margin-left: 0%;
  margin-top: 10px;
}
.cropper {
  width:50%;
  height:400px;
  margin:80px auto;
}
.disqr {
  width:600px;
  height:600px;
  margin:10px auto;
}
.el-tabs__header {
  margin-left: 25%;
  width: 50%;
  margin-top: 40px;
}
@media (max-width:1915px) {
  .disqr {
    width: 300px;
    height: 300px;
  }
}
/* pad */
@media (max-width: 769px) {
  .qrWebInfoForm {
    width: 350px;
    margin: 300px auto auto;
  }
  .button1 {
    background:#fe816d;
    width: 230px;
    margin-left: auto;
    margin-right: auto;
    color:white;
    border: 1px solid #fe816d;
  }
  .button2 {
    background:#38dba4;
    width: 230px;
    color:white;
    margin-top:50px;
    border: 1px solid #38dba4;
  }
}
@media (max-width: 420px) {
  .el-step__title {
    font-size: 12px;
  }
  .cropper {
    width: 350px;
    margin-bottom: 35px;
  }
  .el-upload-dragger {
    width: 280px; 
  }
  .qrWebInfoForm {
    width: 200px;
    margin: 100px auto auto;
  }
  .button1, .button2 {
    width: 200px;
    font-size: 15px;
    margin-top: 0;
    letter-spacing: 0px;
  }
  .button2 {
    margin-top: 25px;
  }
  .button3, .button4, .button5, .button6{
    width: 150px;
    font-size: 15px;
    letter-spacing: 0px;
  }
  .qr-src-uploader {
    margin-top: 30px;
  }
  .cropper {
    height: 200px;
    margin-top: 30px;
  }
  .disqr {
    width: 80%;
    height: auto;
  }
}
</style>
